/*
 *
 * After uncommenting from below - uncomment out the
 * component you want to import in util/ui/index.js
 *
 * We do this to reduce bundle size - cherry pick what we are actiually
 * going to use then import each component only when needed.
 *
 */
// Addons
require('semantic-ui-react/dist/es/addons/Responsive')
// require('semantic-ui-react/dist/es/addons/Confirm')
require('semantic-ui-react/dist/es/addons/Portal')
require('semantic-ui-react/dist/es/addons/Radio')
require('semantic-ui-react/dist/es/addons/Ref')
require('semantic-ui-react/dist/es/addons/Select')
require('semantic-ui-react/dist/es/addons/TextArea')
// require('semantic-ui-react/dist/es/addons/TransitionablePortal')

// Behaviors
require('semantic-ui-react/dist/es/behaviors/Visibility')

// Collections
// require('semantic-ui-react/dist/es/collections/Breadcrumb')
// require('semantic-ui-react/dist/es/collections/Breadcrumb/BreadcrumbDivider')
// require('semantic-ui-react/dist/es/collections/Breadcrumb/BreadcrumbSection')

require('semantic-ui-react/dist/es/collections/Form')
require('semantic-ui-react/dist/es/collections/Form/FormButton')
require('semantic-ui-react/dist/es/collections/Form/FormCheckbox')
require('semantic-ui-react/dist/es/collections/Form/FormDropdown')
require('semantic-ui-react/dist/es/collections/Form/FormField')
require('semantic-ui-react/dist/es/collections/Form/FormGroup')
require('semantic-ui-react/dist/es/collections/Form/FormInput')
require('semantic-ui-react/dist/es/collections/Form/FormRadio')
require('semantic-ui-react/dist/es/collections/Form/FormSelect')
require('semantic-ui-react/dist/es/collections/Form/FormTextArea')

require('semantic-ui-react/dist/es/collections/Grid')
require('semantic-ui-react/dist/es/collections/Grid/GridColumn')
require('semantic-ui-react/dist/es/collections/Grid/GridRow')

require('semantic-ui-react/dist/es/collections/Menu')
require('semantic-ui-react/dist/es/collections/Menu/MenuHeader')
require('semantic-ui-react/dist/es/collections/Menu/MenuItem')
require('semantic-ui-react/dist/es/collections/Menu/MenuMenu')

require('semantic-ui-react/dist/es/collections/Message')
require('semantic-ui-react/dist/es/collections/Message/MessageContent')
require('semantic-ui-react/dist/es/collections/Message/MessageHeader')
// require('semantic-ui-react/dist/es/collections/Message/MessageItem')
// require('semantic-ui-react/dist/es/collections/Message/MessageList')

// require('semantic-ui-react/dist/es/collections/Table')
// require('semantic-ui-react/dist/es/collections/Table/TableBody')
// require('semantic-ui-react/dist/es/collections/Table/TableCell')
// require('semantic-ui-react/dist/es/collections/Table/TableFooter')
// require('semantic-ui-react/dist/es/collections/Table/TableHeader')
// require('semantic-ui-react/dist/es/collections/Table/TableHeaderCell')
// require('semantic-ui-react/dist/es/collections/Table/TableRow')

// Elements
require('semantic-ui-react/dist/es/elements/Button/Button')
require('semantic-ui-react/dist/es/elements/Button/ButtonContent')
require('semantic-ui-react/dist/es/elements/Button/ButtonGroup')
require('semantic-ui-react/dist/es/elements/Button/ButtonOr')

require('semantic-ui-react/dist/es/elements/Container')

require('semantic-ui-react/dist/es/elements/Divider')

// require('semantic-ui-react/dist/es/elements/Flag')

require('semantic-ui-react/dist/es/elements/Header')
require('semantic-ui-react/dist/es/elements/Header/HeaderContent')
require('semantic-ui-react/dist/es/elements/Header/HeaderSubheader')

require('semantic-ui-react/dist/es/elements/Icon')
require('semantic-ui-react/dist/es/elements/Icon/IconGroup')

require('semantic-ui-react/dist/es/elements/Image')
require('semantic-ui-react/dist/es/elements/Image/ImageGroup')

require('semantic-ui-react/dist/es/elements/Input')

require('semantic-ui-react/dist/es/elements/Label')
// require('semantic-ui-react/dist/es/elements/Label/LabelDetail')
// require('semantic-ui-react/dist/es/elements/Label/LabelGroup')

// require('semantic-ui-react/dist/es/elements/List')
// require('semantic-ui-react/dist/es/elements/List/ListContent')
// require('semantic-ui-react/dist/es/elements/List/ListDescription')
// require('semantic-ui-react/dist/es/elements/List/ListHeader')
// require('semantic-ui-react/dist/es/elements/List/ListIcon')
// require('semantic-ui-react/dist/es/elements/List/ListItem')
// require('semantic-ui-react/dist/es/elements/List/ListList')

require('semantic-ui-react/dist/es/elements/Loader')

require('semantic-ui-react/dist/es/elements/Rail')

require('semantic-ui-react/dist/es/elements/Reveal')
require('semantic-ui-react/dist/es/elements/Reveal/RevealContent')

require('semantic-ui-react/dist/es/elements/Segment')
require('semantic-ui-react/dist/es/elements/Segment/SegmentGroup')

// require('semantic-ui-react/dist/es/elements/Step')
// require('semantic-ui-react/dist/es/elements/Step/StepContent')
// require('semantic-ui-react/dist/es/elements/Step/StepDescription')
// require('semantic-ui-react/dist/es/elements/Step/StepGroup')
// require('semantic-ui-react/dist/es/elements/Step/StepTitle')

// Modules
require('semantic-ui-react/dist/es/modules/Accordion/Accordion')
require('semantic-ui-react/dist/es/modules/Accordion/AccordionAccordion')
require('semantic-ui-react/dist/es/modules/Accordion/AccordionContent')
require('semantic-ui-react/dist/es/modules/Accordion/AccordionTitle')

require('semantic-ui-react/dist/es/modules/Checkbox')

require('semantic-ui-react/dist/es/modules/Dimmer')
require('semantic-ui-react/dist/es/modules/Dimmer/DimmerDimmable')

require('semantic-ui-react/dist/es/modules/Dropdown')
require('semantic-ui-react/dist/es/modules/Dropdown/DropdownDivider')
require('semantic-ui-react/dist/es/modules/Dropdown/DropdownHeader')
require('semantic-ui-react/dist/es/modules/Dropdown/DropdownItem')
require('semantic-ui-react/dist/es/modules/Dropdown/DropdownMenu')
// require('semantic-ui-react/dist/es/modules/Dropdown/DropdownSearchInput')

// require('semantic-ui-react/dist/es/modules/Embed')

// require('semantic-ui-react/dist/es/modules/Modal')
// require('semantic-ui-react/dist/es/modules/Modal/ModalActions')
// require('semantic-ui-react/dist/es/modules/Modal/ModalContent')
// require('semantic-ui-react/dist/es/modules/Modal/ModalDescription')
// require('semantic-ui-react/dist/es/modules/Modal/ModalHeader')

require('semantic-ui-react/dist/es/modules/Popup')
require('semantic-ui-react/dist/es/modules/Popup/PopupContent')
// require('semantic-ui-react/dist/es/modules/Popup/PopupHeader')

require('semantic-ui-react/dist/es/modules/Progress')

// require('semantic-ui-react/dist/es/modules/Rating')
// require('semantic-ui-react/dist/es/modules/Rating/RatingIcon')

// require('semantic-ui-react/dist/es/modules/Search')
// require('semantic-ui-react/dist/es/modules/Search/SearchCategory')
// require('semantic-ui-react/dist/es/modules/Search/SearchResult')
// require('semantic-ui-react/dist/es/modules/Search/SearchResults')

// require('semantic-ui-react/dist/es/modules/Sidebar')
// require('semantic-ui-react/dist/es/modules/Sidebar/SidebarPushable')
// require('semantic-ui-react/dist/es/modules/Sidebar/SidebarPusher')

require('semantic-ui-react/dist/es/modules/Sticky')

require('semantic-ui-react/dist/es/modules/Tab')
require('semantic-ui-react/dist/es/modules/Tab/TabPane')

require('semantic-ui-react/dist/es/modules/Transition')
// require('semantic-ui-react/dist/es/modules/Transition/TransitionGroup')

// Views
// require('semantic-ui-react/dist/es/views/Advertisement')

require('semantic-ui-react/dist/es/views/Card/Card')
require('semantic-ui-react/dist/es/views/Card/CardContent')
require('semantic-ui-react/dist/es/views/Card/CardDescription')
require('semantic-ui-react/dist/es/views/Card/CardGroup')
require('semantic-ui-react/dist/es/views/Card/CardHeader')
require('semantic-ui-react/dist/es/views/Card/CardMeta')

// require('semantic-ui-react/dist/es/views/Comment')
// require('semantic-ui-react/dist/es/views/Comment/CommentAction')
// require('semantic-ui-react/dist/es/views/Comment/CommentActions')
// require('semantic-ui-react/dist/es/views/Comment/CommentAuthor')
// require('semantic-ui-react/dist/es/views/Comment/CommentAvatar')
// require('semantic-ui-react/dist/es/views/Comment/CommentContent')
// require('semantic-ui-react/dist/es/views/Comment/CommentGroup')
// require('semantic-ui-react/dist/es/views/Comment/CommentMetadata')
// require('semantic-ui-react/dist/es/views/Comment/CommentText')

require('semantic-ui-react/dist/es/views/Feed')
require('semantic-ui-react/dist/es/views/Feed/FeedContent')
require('semantic-ui-react/dist/es/views/Feed/FeedDate')
// require('semantic-ui-react/dist/es/views/Feed/FeedEvent')
// require('semantic-ui-react/dist/es/views/Feed/FeedExtra')
require('semantic-ui-react/dist/es/views/Feed/FeedLabel')
require('semantic-ui-react/dist/es/views/Feed/FeedLike')
require('semantic-ui-react/dist/es/views/Feed/FeedMeta')
require('semantic-ui-react/dist/es/views/Feed/FeedSummary')
require('semantic-ui-react/dist/es/views/Feed/FeedUser')

// require('semantic-ui-react/dist/es/views/Item')
// require('semantic-ui-react/dist/es/views/Item/ItemContent')
// require('semantic-ui-react/dist/es/views/Item/ItemDescription')
// require('semantic-ui-react/dist/es/views/Item/ItemExtra')
// require('semantic-ui-react/dist/es/views/Item/ItemGroup')
// require('semantic-ui-react/dist/es/views/Item/ItemHeader')
// require('semantic-ui-react/dist/es/views/Item/ItemImage')
// require('semantic-ui-react/dist/es/views/Item/ItemMeta')

// require('semantic-ui-react/dist/es/views/Statistic')
// require('semantic-ui-react/dist/es/views/Statistic/StatisticGroup')
// require('semantic-ui-react/dist/es/views/Statistic/StatisticLabel')
// require('semantic-ui-react/dist/es/views/Statistic/StatisticValue')
